import { useEffect, useState } from 'preact/hooks';
import { logger } from './utils/logger';
import { Product } from './types';
import { useProductVariant } from './useProductVariant';
import { useConfigContext } from './ConfigContext';

export const useData = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [lastTestDate, setLastTestDate] = useState<string | null>(null);

  const variant = useProductVariant();

  const { companyId, apiUrl } = useConfigContext();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetch(`${apiUrl}/api/companies/${companyId}/pip/v5`);
        if (!result.ok) return;

        const { products, lastTestDate } = await result.json();

        logger.log({ products, lastTestDate });
        setProducts(products);
        setLastTestDate(lastTestDate);
      } catch (error) {
        logger.error(error);
      }
    };

    fetchData();
  }, [companyId, apiUrl]);

  useEffect(() => {
    if (!products.length) return;

    // Lookup specific product info
    const parts = location.href.split('/');

    const matchedProduct = products.find(({ slugsToMatch }) =>
      parts.some((part) => slugsToMatch.some((slug) => part.includes(slug))),
    );

    if (matchedProduct) {
      logger.log('Matched Product:', matchedProduct);
    } else {
      logger.log('Failed to match product slugs:', parts);

      if (window.lightlabs.debug) {
        logger.log('Selecting first available product (debug)', products[0]);
        setSelectedProduct(products[0]);
      }

      return;
    }

    setSelectedProduct(matchedProduct);
  }, [products, variant]);

  return { product: selectedProduct, lastTestDate };
};
